'use client'

import { BotIcon, LoaderIcon, MessageSquareTextIcon, SparklesIcon } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

import ArrowBottom from '@/components/shadcn-studio/blocks/hero-section-40/arrow-bottom'
import ArrowRight from '@/components/shadcn-studio/blocks/hero-section-40/arrow-right'
import WorkflowItem from '@/components/shadcn-studio/blocks/hero-section-40/workflow-item'

const AskProspectHunter = () => {
  return (
    <div className='flex max-md:flex-col max-md:space-y-8 md:items-center md:space-x-16'>
      <WorkflowItem
        type='input'
        icon={<SparklesIcon />}
        title='Ask Anything'
        description={'"Who are my hottest leads this week?" or "Draft a follow-up for Acme Corp."'}
        time='0.0 sec'
        className='relative'
      >
        {/* Arrow for large screens */}
        <ArrowRight delay={0.1} />

        {/* Arrow for small screens */}
        <ArrowBottom delay={0.1} />
      </WorkflowItem>

      <WorkflowItem
        type='action'
        icon={<BotIcon />}
        title='AI Processing'
        time='2.1 sec'
        delay={1.2}
        className='relative'
      >
        <div className='bg-muted space-y-2.5 rounded-lg px-2.5 py-3'>
          <div className='flex items-center gap-2'>
            <img
              src='https://cdn.shadcnstudio.com/ss-assets/template/landing-page/orion/image-45.png'
              alt='Notion logo'
              className='size-4.5 dark:invert'
            />
            <span className='text-muted-foreground text-sm'>Querying CRM data</span>
          </div>
          <div className='flex items-center gap-2'>
            <img
              src='https://cdn.shadcnstudio.com/ss-assets/template/landing-page/orion/image-44.png'
              alt='Sheets logo'
              className='size-4.5'
            />
            <span className='text-muted-foreground text-sm'>Analyzing engagement history</span>
          </div>
        </div>
        <div className='bg-muted space-y-2.5 rounded-lg px-2.5 py-3'>
          <div className='text-muted-foreground flex items-center justify-between gap-2'>
            <Badge variant='outline' className='rounded-sm px-1.5'>
              Reasoning...
            </Badge>
            <LoaderIcon className='size-4' />
          </div>
          <p className='text-muted-foreground text-sm'>
            ProspectHunter reasons across your entire sales data to deliver actionable answers.
          </p>
        </div>

        {/* Arrow for large screens */}
        <ArrowRight delay={1.3} />

        {/* Arrow for small screens */}
        <ArrowBottom delay={1.3} />
      </WorkflowItem>

      <WorkflowItem
        type='output'
        icon={<MessageSquareTextIcon />}
        title='Instant Answer'
        description='AI-powered responses with data-backed insights and suggested next actions.'
        time='0.4 sec'
        delay={2.4}
      >
        <div className='bg-muted space-y-2.5 rounded-lg px-2.5 py-3'>
          <Badge variant='outline' className='rounded-sm px-1.5'>
            Answer
          </Badge>
          <p className='text-muted-foreground text-sm'>
            Your top 5 leads by engagement score, with recommended outreach actions attached.
          </p>
          <div className='flex items-center gap-2'>
            <img
              src='https://cdn.shadcnstudio.com/ss-assets/template/landing-page/orion/image-43.png'
              alt='Slack logo'
              className='size-4.5'
            />
            <span className='text-muted-foreground text-sm'>Summary shared</span>
          </div>
        </div>
      </WorkflowItem>
    </div>
  )
}

export default AskProspectHunter
